import { useEffect, useState } from "react";
import { useFormContext } from "react-hook-form";
import { EventApplicationService } from "../../../services";
import eventApplicationCreateModel from "../../../components/Model/EventApplicationModel";
import { routes } from "../../../constants/routes";
import { useNavigate } from "react-router-dom";
import { handleConsoleError } from "../../../utils/common-methods";
import { toast } from "react-toastify";

const RetailTermsAndConditions = () => {
  const [eventApplicationData, setEventApplicationData] = useState({
    ...eventApplicationCreateModel,
  });
  const [showFullText, setShowFullText] = useState(false); // State to toggle text
  const navigate = useNavigate();
  const {
    register,
    getValues,
    formState: { errors },
  } = useFormContext();

  const getApplicationData = async () => {
    try {
      if (getValues("retailApplicationFormData.eventId")) {
        const eventApplication = await EventApplicationService.getEventApplicationByEventId(
          getValues("retailApplicationFormData.eventId"),
          "R"
        );
        if (eventApplication.isSuccess) {
          const applicationMappedData = {
            ...eventApplicationCreateModel,
            ...eventApplication.data?.[0],
          };

          setEventApplicationData(applicationMappedData);
        }
      } else {
        navigate(routes.ERROR);
      }
    } catch (error) {
      const message=handleConsoleError(error);
      toast.error(error?.message|| message);
    }
  };

  useEffect(() => {
    getApplicationData();
  }, []);

  const toggleTextDisplay = () => {
    setShowFullText(!showFullText);
  };

  const termsConditionText = eventApplicationData?.termsCondition || "";
  const displayText =
    termsConditionText.length > 300 && !showFullText
      ? `${termsConditionText.substring(0, 300)}...`
      : termsConditionText;

  return (
    <section>
      <div className="container">
        <h2 className="retail-form-hd1">Terms & Conditions</h2>
        <p
          dangerouslySetInnerHTML={{
            __html: displayText,
          }}
        />
        {termsConditionText.length > 300 && (
          <a
            href="#!"
            onClick={(e) => {
              e.preventDefault();
              toggleTextDisplay();
            }}
          >
            {showFullText ? "Show Less" : "Show More"}
          </a>
        )}
        <div>
          <label style={{ marginTop: "15px" }}>
            <input
              type="radio"             
              value={true}
              {...register("retailApplicationFormData.termsandconditions", {
                required:
                  "Please select an option to confirm your agreement to the terms and conditions.",
              })}
            />{" "}
            I confirm that I have read, understood and agree to comply fully
            with the terms and conditions of contracts for space for traders.
          </label>
        </div>
      </div>
      <div></div>
      {errors.retailApplicationFormData?.termsandconditions && (
        <span className="text-danger" style={{ marginLeft: "15px"}}>
          {errors.retailApplicationFormData.termsandconditions?.message}
        </span>
      )}
    </section>
  );
};

export default RetailTermsAndConditions;
